import { render, staticRenderFns } from "./Podcasts.vue?vue&type=template&id=8353613a&scoped=true"
import script from "./Podcasts.vue?vue&type=script&lang=js"
export * from "./Podcasts.vue?vue&type=script&lang=js"
import style0 from "./Podcasts.vue?vue&type=style&index=0&id=8353613a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8353613a",
  null
  
)

export default component.exports